

let ColorSelectorWidget = function(args) {

    // 1. Find a current color setting in the annotation, if any
    var currentColorBody = args.annotation ?
        args.annotation.bodies.find(function(b) {
            return b.purpose == 'highlighting';
        }) : null;

    // 2. Keep the value in a variable
    var currentColorValue = currentColorBody ? currentColorBody.value : null;

    // 3. Triggers callbacks on user action
    var addTag = function(evt) {
        if (currentColorBody) {
            args.onUpdateBody(currentColorBody, {
                type: 'TextualBody',
                purpose: 'highlighting',
                value: evt.target.dataset.tag
            });
        } else {
            args.onAppendBody({
                type: 'TextualBody',
                purpose: 'highlighting',
                value: evt.target.dataset.tag
            });
        }
    }

    var changeColor = function(evt, input) {
        const newColor = evt.target.value
        evt.target.value = newColor;

        if (currentColorBody) {
            args.onUpdateBody(currentColorBody, {
                type: 'TextualBody',
                purpose: 'highlighting',
                value: evt.target.value
            });
        } else {
            args.onAppendBody({
                type: 'TextualBody',
                purpose: 'highlighting',
                value: evt.target.value
            });
        }
    }

    // 4. This part renders the UI elements
    var createButton = function(value) {
        var button = document.createElement('button');

        if (value === currentColorValue)
            button.className = 'selected';

        button.dataset.tag = value;
        button.style.backgroundColor = value;
        button.addEventListener('click', addTag);
        return button;
    }

    var createInput = function(value){
        var input = document.createElement('input')
        input.setAttribute('type', 'color');
        if( value === currentColorValue){
            input.className = 'selected'
        }

        input.setAttribute('value', value);
        input.style.width = '0';
        input.style.height = '0';
        input.style.opacity = '0';
        input.style.zIndex = '-9999'
        input.dataset.tag = value;
        input.addEventListener('change', changeColor);
        input.select();
        return input;
    }

    var createButtonForInput = function(value, input){
        var button = document.createElement('button');
        button.style.backgroundColor = value;
        button.style.display = 'flex';
        button.style.marginLeft = 'auto'
        button.style.marginRight = '1px'
        button.style.border = `1px solid gray`
        button.style.alignItems = 'center';
        button.style.justifyContent = 'center';
        button.dataset.tag = value;
        button.title = 'Mais cores'

        button.innerHTML =
        `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="18px" width="18px">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>

        `

        if( value === currentColorValue){
            input.className = 'selected'
        }


        button.addEventListener('click', (evt)=>{
            input.click();
        });

        return button;
    }



    var container = document.createElement('div');
    container.className = 'colorselector-widget';

    var buttonRed = createButton('RED');
    var buttonYellow = createButton('YELLOW');
    var buttonPlum = createButton('PLUM');
    var buttonGreen = createButton('GREEN');
    var buttonBlue = createButton('BLUE');
    var buttonOrange = createButton('ORANGE');
    var buttonLightBlue = createButton('LIGHTBLUE');
    var buttonPurple = createButton('PURPLE');
    var buttonBlack = createButton('BLACK');
    var buttonPink = createButton('PINK');
    var inputColor = createInput(currentColorValue ?? '#32a852');
    var buttonPicker = createButtonForInput(currentColorValue ?? '#e3e1e1', inputColor);

    if (!args.readOnly) {

        container.appendChild(buttonRed);
        container.appendChild(buttonYellow);
        container.appendChild(buttonPlum);
        container.appendChild(buttonGreen);
        container.appendChild(buttonBlue);
        container.appendChild(buttonOrange);
        container.appendChild(buttonLightBlue);
        container.appendChild(buttonPurple);
        container.appendChild(buttonBlack);
        container.appendChild(buttonPink);
        container.appendChild(inputColor);
        container.appendChild(buttonPicker);

    }

    return container;
}

export default ColorSelectorWidget;
